import { useParams } from "react-router-dom";

export const useExplorePageSearchTerm = () => {
  const { searchTerm } = useParams<{ searchTerm: string }>();
  return {
    productSearchString: searchTerm.replace(/-/g, " "),
  };
};
